import React from "react";
import { FormikProps, FieldArray } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { BannerFormValues } from "src/models/Banner.model";
import FileUploaderWrapper from "src/components/UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper";

type Props = {
  formikProps: FormikProps<BannerFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const BannerForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Banner" : "Update Banner"}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>

      {/* FieldArray for content */}
      <FieldArray name="content">
        {({ push, remove }) => (
          <div className="flex flex-col gap-4">
            {values.content && values.content.length > 0 ? (
              values.content.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col gap-4 border p-4 rounded-lg relative"
                >
                  {/* Banner Name */}
                  <ATMTextField
                    name={`content[${index}].name`}
                    required
                    value={item.name}
                    onChange={(e) =>
                      setFieldValue(`content[${index}].name`, e.target.value)
                    }
                    label="Name"
                    onBlur={handleBlur}
                  />

                  {/* Banner Image */}
                  <FileUploaderWrapper
                    size="small"
                    label="Banner"
                    required
                    placeholder="Upload Banner"
                    selectedFile={item.image}
                    disabled={false}
                    onSelect={(file) => {
                      setFieldValue(`content[${index}].image`, file);
                    }}
                    name={`content[${index}].image`}
                    accept="image/*"
                  />

                  {/* Remove Button */}
                  {values.content.length > 1 && (
                    <button
                      type="button"
                      className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600"
                      onClick={() => remove(index)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              ))
            ) : (
              <p>No banners added yet</p>
            )}

            {/* Add More Button */}
            <div className="flex justify-end mt-2">
              <button
                type="button"
                onClick={() =>
                  push({
                    name: "",
                    image: null,
                  })
                }
                className="rounded border-dashed border border-slate-500 font-medium text-md text-gray-500 flex items-center gap-1 px-3 py-1 hover:bg-gray-50"
              >
                Add {values.content?.length ? "More" : "Banner"}
              </button>
            </div>
          </div>
        )}
      </FieldArray>

      {/* Submit Button */}
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default BannerForm;
